<template>
  <div class="solutionsForTranslators">
    <div class="summaryContainer">
      <p class="summaryTitle">For Translators</p>
      <p class="summaryContent">Description of product feature in concise manner that wraps to the third line if needed.</p>
      <el-button :plain="true" >Show demo</el-button>
    </div>
    <div class="featureList">
      <div class="feature feature1">
        <div class="featureText">
          <p class="valueProp">VALUE PROP</p>
          <p class="featureTitle">Product Feature 1</p>
          <p class="featureContent">Description of product feature in concise manner that wraps to the third line if needed.</p>
          <p class="learnmorn">Learn more</p>
        </div>
        <div class="featurePicture"></div>
      </div>
        
      <div class="feature feature2">
        <div class="featureText">
          <p class="valueProp">VALUE PROP</p>
          <p class="featureTitle">Product Feature 1</p>
          <p class="featureContent">Description of product feature in concise manner that wraps to the third line if needed.</p>
          <p class="learnmorn">Learn more</p>
        </div>
        <div class="featurePicture"></div>
      </div>

    </div>

    <div class="videoContainer">
      <p class="videoTitle">Resources</p>
      <div class="videoComponent">
        <div class="video1 video">
          <div class="videoContent"></div>
          <div class="videoText">
            <p class="videoSubTitle">Title of Tutorial Video</p>
            <p class="videoDescrption">Description of the video that wraps to the second line</p>
          </div>
        </div>
        <div style="width:52px;vertical-align:bottom;height: 485px;display:inline-block;"></div>
        <div class="video2 video">
          <div class="videoContent"></div>
          <div class="videoText">
            <p class="videoSubTitle">Title of Tutorial Video</p>
            <p class="videoDescrption">Description of the video that wraps to the second line</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'solutionsForTranslators',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.solutionsForTranslators{
    margin-top:40px;
}
.solutionsForTranslators .summaryContainer{height: 743px;background: #F8F8F8;padding-top:271px;}
.solutionsForTranslators .summaryContainer .summaryTitle{
  height: 59px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  text-align: center;
  color: #000000;
  
}
.solutionsForTranslators .summaryContainer .summaryContent{
  width: 714px;
  height: 77px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #000000;
  margin:0 auto;
  margin-top:26px;
}
.solutionsForTranslators .summaryContainer .el-button{
  width: 198px;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  color: #FFFFFF;
  margin:0 auto;
  margin-top:41px;
}
.solutionsForTranslators .summaryContainer .el-button:hover{
  opacity:0.9;
  border-color:#000;
  color:#fff;
}

.solutionsForTranslators .featureList{
  width: 100%;
  background: #FFFFFF;
  padding-top:167px;
}
.solutionsForTranslators .featureList .feature{padding-bottom:145px;}
.solutionsForTranslators .featureList .feature .featureText{
  width:602px;
  height:544px;
  display:inline-block;
  padding-right:127px;
  text-align:left;
  padding-top:144px;
}
.solutionsForTranslators .featureList .feature .featureText .valueProp{
  position: relative;
  width: 150px;
  height: 27px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  color: #AFAFAF;
}
.solutionsForTranslators .featureList .feature .featureText .featureTitle{
  position: relative;
  width: 643px;
  height: 53px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 53px;
  color: #000000;
  margin-top:7px;
}
.solutionsForTranslators .featureList .feature .featureText .featureContent{
  position: relative;
  width: 516px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 36px;
  color: #000000;
  margin-top:18px;
}
.solutionsForTranslators .featureList .feature .featureText .learnmorn{
  position: relative;
  width: 106px;
  height: 23px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #222222;
  margin-top:35px;
}
.solutionsForTranslators .featureList .feature .featurePicture{
  width:556px;
  height:544px;
  background: #FFFFFF;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  display:inline-block;
  vertical-align: bottom;
}
.solutionsForTranslators .videoContainer{
  height: 894px;
  background: #F8F8F8;
  padding-top:99px;
}
.solutionsForTranslators .videoContainer .videoTitle{
  width: 605px;
  height: 59px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  text-align: center;

  color: #000000;
  margin:0 auto;
}
.solutionsForTranslators .videoContainer .videoComponent{
  margin-top:85px;
}
.solutionsForTranslators .videoContainer .videoComponent .video{
  width: 524px;
  height: 485px;
  display:inline-block;
  text-align:left;
}
.solutionsForTranslators .videoContainer .videoComponent .video .videoContent{
  width: 524px;
  height: 327px;
  background: #FFFFFF;
  /* Card Shadow */

  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}
.solutionsForTranslators .videoContainer .videoComponent .video .videoText .videoSubTitle{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 39px;
  color: #000000;
  margin-top:37px;
}
.solutionsForTranslators .videoContainer .videoComponent .video .videoText .videoDescrption{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  color: #000000;
  margin-top:18px;
}
</style>




// WEBPACK FOOTER //
// src/components/SolutionsForTranslators.vue